import React from "react";
import { useHistory } from "react-router-dom";

export const CategoryGroupsList = ({ categories, isLvl1 = false }) => {
    const history = useHistory();

    const handleCategoryClick = (categoryId) => {
        if (isLvl1) {
            history.push(`/riskGroups/lvl2/${categoryId}`);
        } else {
            history.push(`/riskGroups/${categoryId}`);
        }
    };

    return (
        <div className="list gesturedZone risk-groups__list">
            {categories?.map((category) => (
                <div
                    key={category._id}
                    onClick={() => handleCategoryClick(category._id)}
                    className="risk-groups__list-item"
                >
                    <div>
                        <span className="risk-groups__tag">
                            Целевая группа
                        </span>
                        <p>{category.title || category.name}</p>
                    </div>

                    <p className="risk-groups__school">
                        <span>Учеников: {category.pupilsCount || 0}</span>
                    </p>
                </div>
            ))}
        </div>
    );
};
